export interface CustomerWatchlistTotalsDTO {
  customerId: string;
  customerName: string;
  customerEmail: string;
  watchedCount: number;
  latestWatchedDate?: Date;
  latestLoginDate?: Date;
  isOpen: boolean; // for UI
}
